import { QuickbooksAction } from '../types/Finances.types';
import {
  FileText, CreditCard, ClipboardList, Calculator, Coins, Receipt, Undo2, CalendarDays, Clock, UserPlus,
  ArrowUpRight, Wallet, ShoppingBag, CheckSquare, ArrowDownLeft, Shuffle, BookOpen, PackagePlus, MessageSquarePlus
} from 'lucide-react';

export const QUICKBOOKS_ACTIONS: QuickbooksAction[] = [
  // Clientes
  { id: 'invoice', label: 'Factura emitida', category: 'customers', icon: FileText, description: 'Generar una factura de venta para un cliente' },
  { id: 'receive_payment', label: 'Cobro de factura', category: 'customers', icon: CreditCard, description: 'Registrar un cobro por una factura pendiente' },
  { id: 'statement', label: 'Estado de cuenta', category: 'customers', icon: ClipboardList, description: 'Generar un estado de cuenta histórico' },
  { id: 'estimate', label: 'Presupuesto', category: 'customers', icon: Calculator, description: 'Crear un presupuesto o cotización formal' },
  { id: 'credit_note', label: 'Nota de crédito', category: 'customers', icon: Coins, description: 'Emitir una nota de crédito o saldo a favor' },
  { id: 'sales_receipt', label: 'Recibo de venta', category: 'customers', icon: Receipt, description: 'Registrar un recibo de venta cobrado al contado' },
  { id: 'refund_receipt', label: 'Recibo devolución', category: 'customers', icon: Undo2, description: 'Efectuar un reembolso o devolución' },
  { id: 'delayed_credit', label: 'Crédito diferido', category: 'customers', icon: CalendarDays, description: 'Registrar un crédito comercial diferido' },
  { id: 'delayed_charge', label: 'Cargo diferido', category: 'customers', icon: Clock, description: 'Programar un cargo financiero diferido' },
  { id: 'add_customer', label: 'Alta de cliente', category: 'customers', icon: UserPlus, description: 'Dar de alta un nuevo cliente' },

  // Proveedores
  { id: 'expense', label: 'Gasto directo', category: 'suppliers', icon: ArrowUpRight, description: 'Registrar un gasto operativo directo' },
  { id: 'cheque', label: 'Cheque bancario', category: 'suppliers', icon: Wallet, description: 'Emitir y registrar un cheque de pago' },
  { id: 'bill', label: 'Factura recibida', category: 'suppliers', icon: FileText, description: 'Cargar una factura pendiente recibida de un acreedor' },
  { id: 'pay_bills', label: 'Pago a proveedores', category: 'suppliers', icon: Coins, description: 'Gestionar y liquidar facturas de acreedores' },
  { id: 'purchase_order', label: 'Orden de compra', category: 'suppliers', icon: ShoppingBag, description: 'Emitir una orden de compra oficial' },
  { id: 'supplier_credit', label: 'Abono de proveedor', category: 'suppliers', icon: Receipt, description: 'Registrar un abono o nota de crédito de acreedor' },
  { id: 'credit_card_credit', label: 'Abono en tarjeta', category: 'suppliers', icon: CreditCard, description: 'Declarar un abono o devolución en tarjeta de crédito' },
  { id: 'add_supplier', label: 'Alta de proveedor', category: 'suppliers', icon: UserPlus, description: 'Dar de alta un nuevo acreedor comercial' },

  // Otros
  { id: 'task', label: 'Tarea contable', category: 'other', icon: CheckSquare, description: 'Asignar o registrar una tarea contable pendiente' },
  { id: 'bank_deposit', label: 'Depósito bancario', category: 'other', icon: ArrowDownLeft, description: 'Registrar un depósito bancario o inyección de capital' },
  { id: 'transfer', label: 'Transferencia', category: 'other', icon: Shuffle, description: 'Mover fondos entre cuentas internas' },
  { id: 'journal_entry', label: 'Asiento de diario', category: 'other', icon: BookOpen, description: 'Realizar un asiento de contabilidad de doble entrada' },
  { id: 'pay_down_credit_card', label: 'Liquidación tarjeta', category: 'other', icon: ArrowUpRight, description: 'Registrar pago de liquidación de tarjeta de crédito' },
  { id: 'add_product_service', label: 'Añadir producto/servicio', category: 'other', icon: PackagePlus, description: 'Crear un nuevo ítem del catálogo o servicio' },
  { id: 'new_chat', label: 'Consulta contable', category: 'other', icon: MessageSquarePlus, description: 'Iniciar un hilo con el asesor contable Inteligente' }
];

export const INITIAL_TRANSACTIONS = [
  { id: 'TX-9921', desc: 'Factura Distribución #882', amount: 1240.00, type: 'income', date: '2026-05-25', service: 'sales_receipt' },
  { id: 'TX-9920', desc: 'Pago Proveedor Papelera S.A.', amount: -3450.00, type: 'expense', date: '2026-05-24', service: 'expense' },
  { id: 'TX-9919', desc: 'Venta Online Librería Central', amount: 450.20, type: 'income', date: '2026-05-24', service: 'invoice' },
  { id: 'TX-9918', desc: 'Suministros Eléctricos Hub Madrid', amount: -890.50, type: 'expense', date: '2026-05-23', service: 'bill' },
  { id: 'TX-9917', desc: 'Factura Amazon ES #772', amount: 3420.00, type: 'income', date: '2026-05-22', service: 'invoice' },
];

export const INITIAL_BANK_ACCOUNTS = [
  { id: 'wise-eur', name: 'WISE EUR', balance: 0.19, qbBalance: 936.91, alert: true },
  { id: 'wise-mxn', name: 'WISE MXN', balance: 0.00, qbBalance: 387922.79, alert: true, currency: 'MXN' },
  { id: 'wise-pln', name: 'WISE PLN', balance: 14242.00, qbBalance: 14242.00, alert: false, currency: 'PLN' },
];

import { ClientData, ProductData, JournalEntry } from '../types/Finances.types';

export const PRESET_CLIENTS: ClientData[] = [
  { id: 'C-001', name: 'Librería Central Madrid S.L.', contactPerson: 'Carlos Gómez', email: 'cgomez@central.es', cif: 'B81234567', phone: '+34 91 521 1234', address: 'Calle Mayor 4, 28013 Madrid' },
  { id: 'C-002', name: 'Marcial Pons Librería Barcelona', contactPerson: 'Mercedes Pons', email: 'm.pons@marcialpons.es', cif: 'B82345678', phone: '+34 93 301 5678', address: 'Carrer de Pau Claris 162, 08037 Barcelona' },
  { id: 'C-003', name: 'Distribuciones Siglo XXI', contactPerson: 'Juan Ignacio', email: 'jignacio@sigloxxi.com', cif: 'B85544332', phone: '+34 91 600 7700', address: 'Av. de la Industria 45, 28108 Alcobendas, Madrid' },
  { id: 'C-004', name: 'Universidad Complutense de Madrid', contactPerson: 'Dr. Alejandro Ruiz', email: 'compras.pdi@ucm.es', cif: 'Q2818001F', phone: '+34 91 394 1000', address: 'Av. Séneca 2, Ciudad Universitaria, 28040 Madrid' },
  { id: 'C-005', name: 'La Casa del Libro', contactPerson: 'Laura Méndez', email: 'lmendez@casadellibro.es', cif: 'A82003344', phone: '+34 902 151 525', address: 'Gran Vía 29, 28013 Madrid' }
];

export const PRESET_PRODUCTS: ProductData[] = [
  { id: 'P-001', name: 'Manual de Derecho Constitucional (Vol. 1)', defaultPrice: 35.00, defaultVat: 4, sku: '978-84-1355-120-1' },
  { id: 'P-002', name: 'Tratado de Derecho Civil Español', defaultPrice: 85.00, defaultVat: 4, sku: '978-84-1355-230-7' },
  { id: 'P-003', name: 'Suscripción Anual Revista de Jurisprudencia', defaultPrice: 120.00, defaultVat: 10, sku: 'S-RV-JURIS' },
  { id: 'P-004', name: 'Acceso Licencia Premium BaaS Platform', defaultPrice: 250.00, defaultVat: 21, sku: 'LIC-BAAS-PREM' },
  { id: 'P-005', name: 'Gastos de Envío & Logística Editorial', defaultPrice: 9.90, defaultVat: 21, sku: 'LOG-SHIPPING' }
];

export const CUENTAS_PGC = [
  { code: '100000', name: 'Capital Social' },
  { code: '129000', name: 'Resultado del Ejercicio (Pérdidas y Ganancias)' },
  { code: '170000', name: 'Deudas a L/P con entidades de crédito' },
  { code: '217000', name: 'Equipos para procesos de información (Informática)' },
  { code: '281700', name: 'Amortización acumulada de equipos de informática' },
  { code: '300000', name: 'Mercaderías' },
  { code: '400000', name: 'Proveedores (Euros)' },
  { code: '410000', name: 'Acreedores por prestaciones de servicios' },
  { code: '430000', name: 'Clientes (Euros)' },
  { code: '431000', name: 'Clientes, efectos comerciales en cartera (Remesas)' },
  { code: '472000', name: 'H.P. IVA Soportado (Compras)' },
  { code: '475000', name: 'H.P. Acreedora por IVA (Liquidación)' },
  { code: '475100', name: 'H.P. Acreedora por Retenciones (IRPF)' },
  { code: '477000', name: 'H.P. IVA Repercutido (Ventas)' },
  { code: '520000', name: 'Deudas a C/P con entidades de crédito' },
  { code: '570000', name: 'Caja, euros' },
  { code: '572000', name: 'Bancos c/c (WISE EUR)' },
  { code: '600000', name: 'Compras de mercaderías' },
  { code: '628000', name: 'Suministros (Agua, luz, internet)' },
  { code: '629000', name: 'Otros servicios (Gastos diversos)' },
  { code: '669000', name: 'Otros gastos financieros' },
  { code: '681000', name: 'Amortización del inmovilizado material' },
  { code: '700000', name: 'Ventas de mercaderías' },
  { code: '705000', name: 'Prestación de servicios' }
];

export const INITIAL_ENTRIES: JournalEntry[] = [
  {
    id: 'AS-2026-001',
    date: '2026-01-01',
    concept: 'ASIENTO DE APERTURA EJERCICIO CONTABLE 2026',
    status: 'posted',
    sourceModule: 'Arrastre de Saldos',
    lines: [
      { account: '217000', accountName: 'Equipos para procesos de información', debit: 3500.00, credit: 0 },
      { account: '300000', accountName: 'Mercaderías', debit: 6000.00, credit: 0 },
      { account: '572000', accountName: 'Bancos c/c (WISE EUR)', debit: 25400.00, credit: 0 },
      { account: '100000', accountName: 'Capital Social', debit: 0, credit: 28000.00 },
      { account: '129000', accountName: 'Resultado del Ejercicio', debit: 0, credit: 6900.00 }
    ]
  },
  {
    id: 'AS-2026-002',
    date: '2026-01-15',
    concept: 'FACTURA DE VENTA EMITIDA F2026-102 A EDITORIAL SOL',
    status: 'posted',
    sourceModule: 'Factura Emitida',
    lines: [
      { account: '430000', accountName: 'Clientes (Euros)', debit: 1210.00, credit: 0 },
      { account: '700000', accountName: 'Ventas de mercaderías', debit: 0, credit: 1000.00 },
      { account: '477000', accountName: 'H.P. IVA Repercutido (Ventas)', debit: 0, credit: 210.00 }
    ]
  },
  {
    id: 'AS-2026-003',
    date: '2026-01-18',
    concept: 'PAGO DE SUMINISTROS OFICINA ELECTRA S.A.',
    status: 'posted',
    sourceModule: 'Factura Recibida',
    lines: [
      { account: '628000', accountName: 'Suministros (Agua, luz, internet)', debit: 180.00, credit: 0 },
      { account: '472000', accountName: 'H.P. IVA Soportado (Compras)', debit: 37.80, credit: 0 },
      { account: '410000', accountName: 'Acreedores por prestaciones de servicios', debit: 0, credit: 217.80 }
    ]
  },
  {
    id: 'AS-2026-015',
    date: '2026-02-10',
    concept: 'RECONCILIACIÓN PAGO PROVEEDOR PAPELERA DE ALCALÁ',
    status: 'posted',
    sourceModule: 'Bancos para conciliación',
    lines: [
      { account: '400000', accountName: 'Proveedores (Euros)', debit: 500.00, credit: 0 },
      { account: '572000', accountName: 'Bancos c/c (WISE EUR)', debit: 0, credit: 500.00 }
    ]
  }
];

export const BACKUP_INITIAL_ENTRIES: JournalEntry[] = [
  {
    id: 'AS-2026-001',
    date: '2026-01-01',
    concept: 'ASIENTO DE APERTURA EJERCICIO CONTABLE 2026',
    status: 'posted',
    sourceModule: 'Arrastre de Saldos',
    lines: [
      { account: '217000', accountName: 'Equipos para procesos de información', debit: 3500.00, credit: 0 },
      { account: '300000', accountName: 'Mercaderías', debit: 6000.00, credit: 0 },
      { account: '572000', accountName: 'Bancos c/c (WISE EUR)', debit: 25400.00, credit: 0 },
      { account: '100000', accountName: 'Capital Social', debit: 0, credit: 28000.00 },
      { account: '129000', accountName: 'Resultado del Ejercicio', debit: 0, credit: 6900.00 }
    ]
  },
  {
    id: 'AS-2026-002',
    date: '2026-01-15',
    concept: 'FACTURA DE VENTA EMITIDA F2026-102 A EDITORIAL SOL',
    status: 'posted',
    sourceModule: 'Factura Emitida',
    lines: [
      { account: '430000', accountName: 'Clientes (Euros)', debit: 1210.00, credit: 0 },
      { account: '700000', accountName: 'Ventas de mercaderías', debit: 0, credit: 1000.00 },
      { account: '477000', accountName: 'H.P. IVA Repercutido (Ventas)', debit: 0, credit: 210.00 }
    ]
  }
];